import { gql } from '@lcs/shared/api';

export const DeleteDashboardMutation = gql`
   mutation DeleteDashboard($id: UInt!) {
      deleteDashboard(id: $id)
   }
`;
